module.exports = __webpack_public_path__ + "img/enston.eba69c7c.svg";